function once(fn) {
  let pr = null;
  return function(...args) {
    if (pr === null) {
      try {
        pr = fn(...args);
      } catch (e) {
        pr = Promise.reject(e);
      }
    }
    return pr;
  };
}
export {
  once
};
//# sourceMappingURL=Once.js.map
